var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwoopWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 951.19 167.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-4 {\n        fill: #1d2956;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 919.06,
    height: 167.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,33.52s258.38-9.4,391.59,12c133.21,21.4,405.82,49.35,559.6-45.52H0v33.52Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M.83,138.99L0,138.29c.37-.35,37.83-35.59,95.83-65.68,34.07-17.68,68.46-30.16,102.21-37.09,42.21-8.67,83.53-8.63,122.83.1,13.77,3.06,28.96,6.63,45.04,10.42,135.73,31.93,340.85,80.18,472.92,10.16,55.31-29.32,92.74-77.54,111.26-143.31l1.11.25c-18.6,66.04-56.21,114.47-111.79,143.94-45.61,24.18-99.88,34.31-156.97,35.9-108.72,3.01-227.7-24.98-316.82-45.95-16.08-3.78-31.27-7.36-45.02-10.41-39.11-8.69-80.25-8.72-122.28-.1-33.64,6.91-67.92,19.34-101.88,36.97C38.57,103.5,1.2,138.64.83,138.99Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwoopWhite);
export default __webpack_public_path__ + "static/media/swoop-white.bd7b5b417c349850b7b03877b8583587.svg";
export { ForwardRef as ReactComponent };